import { useState } from 'react';
import { useEnterTenantContext, useMe, usePlatformTenants } from '../api/queries';
import { useSession } from '../auth/session';
import { useTranslate } from '../i18n/useTranslate';

/**
 * "Kurum olarak görüntüle" — platform yöneticisine özel (SEOAI-81).
 *
 * Normal kurum değiştiricisinden AYRI bir denetimdir ve bilinçli olarak öyle
 * görünür: biri "üyesi olduğum kurumlar arasında geçiş", diğeri "üyesi
 * olmadığım bir kurumu denetleme". İkisini tek listede birleştirmek, farklı
 * yetkilerle gelen iki yeteneği aynı şeymiş gibi gösterirdi — ve bu geçişin
 * denetim kaydı bıraktığı gerçeğini gizlerdi.
 *
 * Normal kullanıcıya HİÇ çizilmez ve listesi de ÇEKİLMEZ.
 *
 * Bağlam SALT-OKUNURDUR (SEOAI-81 incelemesi) ve rozet bunu söyler: sunucu
 * platform bağlamında yalnızca okuma izinleri döndürür, dolayısıyla menü ve
 * butonlar zaten daralır — ama kullanıcının NEDEN daraldığını görmesi gerekir.
 */
export function PlatformTenantPicker() {
  const t = useTranslate();
  const me = useMe();
  const isPlatformAdmin = me.data?.isSuperAdmin === true;

  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState('');
  const tenants = usePlatformTenants(page, isPlatformAdmin);
  const enter = useEnterTenantContext();
  const activeTenantId = useSession((s) => s.tenantId);

  if (!isPlatformAdmin) return null;

  const items = tenants.data?.items ?? [];
  const lastPage = tenants.data?.lastPage ?? 1;

  return (
    <section className="platform" aria-label={t('platform.hint')}>
      <span className="badge">{t('platform.hint')}</span>
      <span className="badge">{t('platform.readonly')}</span>

      <label>
        {t('platform.label')}
        <select
          value={selected}
          disabled={enter.isPending}
          onChange={(event) => setSelected(event.target.value)}
        >
          <option value="">{t('platform.placeholder')}</option>
          {items.map((tenant) => (
            <option key={tenant.id} value={tenant.id}>
              {tenant.name}
            </option>
          ))}
        </select>
      </label>

      <button
        type="button"
        disabled={selected === '' || selected === activeTenantId || enter.isPending}
        onClick={() => enter.mutate(selected)}
      >
        {t('platform.view')}
      </button>

      {/* Sayfalama GÖRÜNÜR: sessizce ilk sayfayı göstermek, listeyi eksik
          olduğunu bilmeden okumaya davet ederdi. */}
      {lastPage > 1 && (
        <span className="hint">
          <button type="button" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
            {t('platform.prev')}
          </button>
          {t('platform.page', { page, lastPage, total: tenants.data?.total ?? 0 })}
          <button type="button" disabled={page >= lastPage} onClick={() => setPage((p) => p + 1)}>
            {t('platform.next')}
          </button>
        </span>
      )}

      {enter.isPending && <span className="hint">{t('platform.entering')}</span>}
    </section>
  );
}
